import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@/app/providers/AuthProvider';
import { NotifyProvider } from '@/app/providers/NotifyProvider';
import { router } from '@/app/router';
import { ApiError } from '@/services/api';
import { reloadForNewVersion } from '@/utils/app-version';
import '@/styles/brand.css';

// A page's code was replaced by a new deployment while this tab was open: load the new version.
window.addEventListener('vite:preloadError', (e) => {
  if (reloadForNewVersion()) e.preventDefault();
});

// Legacy client links of the original used a hash route (#/client/<token>).
if (location.hash.startsWith('#/client/')) {
  history.replaceState(null, '', '/client/' + location.hash.slice('#/client/'.length));
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <NotifyProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </NotifyProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
